module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/th_2-5e4c1e7afce4f8a506f7e5bdaeb87be7.jpg";